import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-4 px-4 border-t border-gray-100" data-id="element-176">
      <div className="max-w-3xl mx-auto text-center" data-id="element-177">
        <div className="flex justify-center mb-2" data-id="element-178">
          <ShieldCheckIcon className="w-14 h-14 text-green-600" strokeWidth={1.5} data-id="element-179" />
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1" data-id="element-180">
          Garantía de Satisfacción Total
        </h2>

        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-181">
          Probalo 7 días. Si no cumple tus expectativas, te devolvemos el 100%.{' '}
          <br data-id="element-182" />
          <span className="font-bold text-gray-900" data-id="element-183">Sin preguntas.</span>
        </p>
      </div>
    </section>;
}